import {
  getPayments, postPayment, putPayment, exportPayments, importPayments,
} from '../../../Api/services/backoffice';

import status from '../../../Utils/Select/optionsLists/status';

export const key = 'payment';

const entityName = {
  singular: 'Vendedor',
  plural: 'Vendedores',
};

const queries = {
  list: { key, fn: getPayments },
  detail: { key },
};

const mutations = {
  create: postPayment,
  update: putPayment,
};

const fields = {
  table: [
    { key: 'code', label: 'Código' },
    { key: 'description', label: 'Descrição' },
    { key: 'parameterExtra', label: 'Forma de Pagamento' },
    { key: 'newParameterExtra', label: 'Parâmetros Extras' },
    { key: 'tax', label: 'Taxa Condição de Pagamento (%)' },
    { key: 'taxFixed', label: 'Taxa Fixa por Transação (R4)' },
    { key: 'daysTerm', label: 'Prazo de pagamento (dias)' },
    { key: 'active', label: 'Status', mustRender: { componentType: 'status' } },
  ],
  search: [
    {
      param: 'search',
      label: 'Buscar',
      type: 'text',
    },
    {
      param: 'active',
      label: 'Status',
      type: 'select',
      options: status,
    },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
  showBatchButton: true,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};

export const batchConfig = {
  entityName: entityName.plural,
  exportFn: exportPayments,
  importFn: importPayments,
};
